/** @jsx h */
import { h } from 'preact'
import Icon from './icons/icons'
import clsx from 'clsx'
import { useCombobox } from 'downshift'
import { useEffect, useState } from 'preact/hooks'
import { useGlobal } from '../use-global'

const Select = ({ options, hasError, disabled, required, value, onChange, className }) => {
  const [{ canvasConfig }] = useGlobal()
  const [items, setItems] = useState(options)
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    getItemProps,
    selectedItem,
    setInputValue
  } = useCombobox({
    onInputValueChange({ inputValue }) {
      const lowerCasedInputValue = inputValue.toLowerCase()
      setItems(
        options.filter(
          option =>
            option.value.toLowerCase().includes(lowerCasedInputValue) ||
            option.country.toLowerCase().includes(lowerCasedInputValue)
        )
      )
    },
    items,
    itemToString: item => (item ? item.value : ''),
    onSelectedItemChange: onChange,
    selectedItem: value,
    initialInputValue: value
  })

  useEffect(() => {
    setInputValue(value)
  }, [value])

  return (
    <div
      className={clsx('rcc-relative rcc-flex rcc-gap-1.5 rcc-items-center rcc-border-b', {
        'rcc-border-danger rcc-text-danger': hasError,
        'rcc-border-gray-light rcc-text-text': !hasError,
        'rcc-flex-row-reverse': canvasConfig.direction === 'rtl'
      })}
    >
      <div>
        <input
          className={clsx('rcc-cursor-pointer rcc-bg-transparent rcc-text-sm rcc-h-[24.8px]', className, {
            'rcc-text-left': canvasConfig.direction === 'ltr',
            'rcc-text-right': canvasConfig.direction === 'rtl'
          })}
          {...getInputProps()}
          required={required}
          disabled={disabled}
          aria-label='Prefix number'
        />
        <button
          type='button'
          className='rcc-bg-transparent rcc-cursor-pointer'
          aria-label='Open list of prefix numbers'
          {...getToggleButtonProps()}
        >
          <Icon name='arrow' width={'10'} height={'10'} />
        </button>
      </div>
      <ul
        className={clsx('rcc-bg-white rcc-absolute rcc-overflow-y-auto rcc-z-10 rcc-m-0 rcc-p-0 rcc-top-[100%]', {
          'rcc-border rcc-border-gray-light': isOpen,
          'rcc-text-right': canvasConfig.direction === 'rtl'
        })}
        {...getMenuProps()}
        style={{
          maxHeight: 250,
          width: 200
        }}
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={clsx('rcc-cursor-pointer rcc-p-2 rcc-text-text rcc-text-sm rcc-list-none', {
                'rcc-bg-gray-very-light': highlightedIndex === index,
                'rcc-font-bold': selectedItem === item.value
              })}
              key={`${index}-${item.label}`}
              {...getItemProps({
                key: item.label,
                index,
                item
              })}
            >
              {item.value} {item.country}
            </li>
          ))}
      </ul>
    </div>
  )
}

export default Select
